/* eslint-disable jsx-a11y/anchor-has-content,no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import Common from '../shared/common';
import { FormattedMessage, injectIntl } from "react-intl";
import * as paymentCertificateCrud from '../crud/paymentCertificate.crud';
import { withRouter } from '../shared/hoc/withRouter';
import SystemHelper from "../shared/systemHelper";

const spanStyleViewRegister = {
    whiteSpace: 'normal',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    paddingBottom: 0,
};

const styles = {
    scrollContainer: {
        display: 'flex',
        flexDirection: 'row',
        overflowX: 'auto',
        overflowY: 'hidden',
        width: '100%',
        paddingBottom: '10px',
        scrollSnapType: 'x mandatory',
        scrollbarWidth: 'thin',
    },
    currencyCard: {
        flex: '0 0 33.333%',
        minWidth: '33.333%',
        padding: '0 20px',
        borderRight: '1px solid #ebedf2',
        scrollSnapAlign: 'start',
        boxSizing: 'border-box'
    }
};

class MultipleContractPayments extends React.Component {
    state = {
        allPaymentsData: [] // Stores array of { currencyCode, appliedAmount, certifiedAmount, etc. }
    }

    componentDidMount() {
        this.refreshAllPayments();
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.contract.currencyoptions) !== JSON.stringify(this.props.contract.currencyoptions)) {
            this.refreshAllPayments();
        }
    }

    refreshAllPayments = async () => {
        let currencyOptions = this.props.contract.currencyoptions || [];

        // Dummy Data Mode: Force 3 currencies if ID is 0
        if (this.props.contract.contractid === 0) {
            currencyOptions = [{ currency: 'GBP' }, { currency: 'EUR' }, { currency: 'USD' }];
        }

        const dataPromises = currencyOptions.map(option => this.getPaymentDataForCurrency(option.currency));
        const results = await Promise.all(dataPromises);
        this.setState({ allPaymentsData: results.filter(r => r !== null) });
    }

    getPaymentDataForCurrency = async (currencyCode) => {
        try {
            let data = {
                currencyCode,
                appliedAmount: 0,
                certifiedAmount: 0,
                lastCommunicatedPaymentCertificateId: 0,
                lastCommunicatedPaymentApplicationId: 0
            };

            if (this.props.contract.contractid > 0) {
                const { data: resp } = await paymentCertificateCrud.getLastPaymentAmounts(
                    this.props.contract.contractid, 
                    ["Certificate", "Application"], 
                    [currencyCode], 
                    ''
                );

                if (resp && resp.length > 0) {
                    data.appliedAmount = resp.find(x => x.paymenttype === 'Application')?.amount || 0;
                    data.certifiedAmount = resp.find(x => x.paymenttype === 'Certificate')?.amount || 0;
                    data.lastCommunicatedPaymentCertificateId = resp.find(x => x.paymenttype === 'Certificate')?.lastcommunicatedpaymentcertificateid;
                    data.lastCommunicatedPaymentApplicationId = resp.find(x => x.paymenttype === 'Application')?.lastcommunicatedpaymentapplicationid;
                }
            } else {
                // Dummy Data values
                data.appliedAmount = 85000;
                data.certifiedAmount = 70000;
            }

            return data;
        } catch (err) {
            console.error(err);
            return null;
        }
    }

    render() {
        const { globalResources } = this.props;
        const { allPaymentsData } = this.state;
        const hasWorkflows = globalResources && (globalResources.WF_20_TITLE || globalResources.WF_21_TITLE);

        if (!hasWorkflows || !allPaymentsData || allPaymentsData.length === 0) {
            return (
                <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <span style={{ fontFamily: SystemHelper.getThemeTextFont(), fontSize: '1.1rem', color: '#74788d', textAlign: 'center' }}>
                        <FormattedMessage id="CONTRACT.DASHBOARD.PAYMENTS_NOT AVAILABLE" />
                    </span>
                </div>
            );
        }

        // 1. DEFINE ROWS BASED ON WORKFLOWS
        // We create a static master list based on the available workflow titles
        const paymentRows = [];
        if (globalResources.WF_21_TITLE) {
            paymentRows.push({ 
                id: 'applied', 
                label: globalResources.WF_21_TITLE, 
                amountKey: 'appliedAmount', 
                idKey: 'lastCommunicatedPaymentApplicationId',
                path: 'supplier'
            });
        }
        if (globalResources.WF_20_TITLE) {
            paymentRows.push({ 
                id: 'certified', 
                label: globalResources.WF_20_TITLE, 
                amountKey: 'certifiedAmount', 
                idKey: 'lastCommunicatedPaymentCertificateId',
                path: 'pm'
            });
        }

        return (
            <div className="kt-widget14" style={{ width: '100%' }}>
                {/* MAIN HEADER */}
                <div className="kt-widget14__header" style={{ marginBottom: '20px' }}>
                    <h3 className="kt-widget14__title">
                        {this.props.title ? this.props.title : globalResources.WFG_108_TITLE}
                    </h3>
                </div>

                <div style={{ overflowX: 'auto' }} className="custom-horizontal-scroll">
                    {/* DYNAMIC WIDTH: Label (300px) + 180px per currency */}
                    <div className="kt-widget12" style={{ minWidth: `${300 + (allPaymentsData.length * 180)}px` }}>
                        
                        {/* COLUMN HEADERS: Currency Codes */}
                        <div style={{ display: 'flex', alignItems: 'center', paddingBottom: '15px', borderBottom: '1px solid #ebedf2', marginBottom: '15px' }}>
                            <div style={{ flex: '0 0 300px' }}></div> 
                            {allPaymentsData.map((data, index) => (
                                <div 
                                    key={data.currencyCode} 
                                    style={{ 
                                        flex: '1', 
                                        textAlign: 'center', 
                                        paddingRight: '15px',
                                        //borderLeft: index > 0 ? '1px solid #ebedf2' : 'none' 
                                        borderLeft: '1px solid #ebedf2'
                                    }}
                                >
                                    <span className="kt-widget14__title" style={{ fontSize: '1.1rem', fontWeight: '500' }}>
                                        {data.currencyCode}
                                    </span>
                                </div>
                            ))}
                        </div>

                        {/* DATA ROWS */}
                        <div className="kt-widget12__content">
                            {paymentRows.map((row) => (
                                <div 
                                    key={row.id} 
                                    className="kt-widget12__item" 
                                    style={{ display: 'flex', alignItems: 'center', marginBottom: '1.2rem' }}
                                >
                                    {/* LEFT SIDE: Single Label */}
                                    <div className="kt-widget12__info" style={{ flex: '0 0 300px' }}>
                                        <span className="kt-widget12__desc" style={{ ...spanStyleViewRegister, fontSize: '1rem' }}>
                                            {row.label}
                                        </span>
                                    </div>

                                    {/* RIGHT SIDE: Values for each currency */}
                                    {allPaymentsData.map((data, cIdx) => {
                                        const amount = data[row.amountKey];
                                        const recordId = data[row.idKey];

                                        return (
                                            <div 
                                                key={`${data.currencyCode}-${row.id}`} 
                                                className="kt-widget12__info" 
                                                style={{ 
                                                    flex: '1', 
                                                    display: 'flex', 
                                                    alignItems: 'center',
                                                    paddingRight: '15px',
                                                    //borderLeft: cIdx > 0 ? '1px solid #ebedf2' : 'none',
                                                    borderLeft: '1px solid #ebedf2',
                                                    minHeight: '40px'
                                                }}
                                            >
                                                {/* Column 1: Amount */}
                                                <div style={{ flex: 1, textAlign: 'right' }}>
                                                    <span className="contractPayments__price" style={{ fontSize: '1.1rem', color: '#595d6e', fontWeight: 'normal' }}>
                                                        {Common.FormatCurrencyNum(amount, data.currencyCode)}
                                                    </span>
                                                </div>

                                                {/* Column 2: Link Placeholder */}
                                                <div style={{ width: '80px', textAlign: 'right', marginLeft: '10px' }}>
                                                    {recordId > 0 ? (
                                                        <span className="kt-widget12__desc" style={spanStyleViewRegister}>
                                                            <a 
                                                                onClick={() => this.props.navigate(`/contract/${this.props.contract.contractid}/payments/${row.path}/${recordId}`)}
                                                                style={{ textDecoration: 'underline', cursor: 'pointer', fontSize: '1rem' }}
                                                            >
                                                                <FormattedMessage id="CONTRACT.DASHBOARD.VIEW" />
                                                            </a>
                                                        </span>
                                                    ) : (
                                                        <div style={{ height: '1px' }}></div>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(withRouter(MultipleContractPayments));